import { Component, HostListener, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { UIConfirmDialogService, UIModule } from '@bannerflow/ui';
import { AIStudioCanvasComponent } from './ai-studio-canvas/ai-studio-canvas.component';
import { AiStudioSidebarComponent } from './ai-studio-sidebar/ai-studio-sidebar.component';
import { AIStudioTopbarComponent } from './ai-studio-topbar/ai-studio-topbar.component';
import { GenAIService } from './state/gen-ai.service';
import { UndoRedoTooltipComponent } from './undo-redo-tooltip/undo-redo-tooltip.component';
import { ZoomTooltipComponent } from './zoom-tooltip/zoom-tooltip.component';

@Component({
    selector: 'ai-studio',
    templateUrl: 'ai-studio.component.html',
    styleUrls: ['ai-studio.component.scss'],
    imports: [
        UIModule,
        AIStudioCanvasComponent,
        AIStudioTopbarComponent,
        AiStudioSidebarComponent,
        UndoRedoTooltipComponent,
        ZoomTooltipComponent
    ]
})
export class AIStudioComponent {
    private readonly genAIService = inject(GenAIService);
    private readonly uiConfirmDialogService = inject(UIConfirmDialogService);
    private hasUnsavedChanges = toSignal(this.genAIService.hasUnsavedChanges$, { initialValue: false });
    private isConfirmDialogOpen = false;

    @HostListener('document:keydown.escape', ['$event'])
    async onEscape(event: KeyboardEvent): Promise<void> {
        if (this.isConfirmDialogOpen) {
            return;
        }
        event.stopPropagation();

        if (!this.hasUnsavedChanges()) {
            this.genAIService.closeAIStudio();
            return;
        }

        this.isConfirmDialogOpen = true;
        const result = await this.uiConfirmDialogService.confirm({
            headerText: 'Exit without saving',
            confirmText: 'Exit without saving',
            discardText: 'Back to AI Studio',
            text: `You are about to exit the AI Studio view. All unsaved changes to the image will be lost.\n If you want to save your image, please return to the AI Studio.`,
            showCancelButton: false
        });
        this.isConfirmDialogOpen = false;

        if (result === 'confirm') {
            this.genAIService.closeAIStudio();
        }
    }
}
